// Nombres oficiales de empresa. Los datos históricos vienen en formatos distintos
// ("B2b", "VICSA", "bunzl", "Dps"...); todo se muestra y se guarda con estos nombres.
export const EMPRESAS_PRINCIPALES = ['Vicsa', 'B2B', 'Tecnoboga', 'Bunzl'];
export const EMPRESAS_OTROS = ['DPS', 'Hospitalia', 'Vicsa Uruguay'];

export function normalizarEmpresa(raw) {
  const texto = String(raw ?? '').trim();
  if (!texto) return '';
  const l = texto.toLowerCase().replace(/[\s._-]+/g, ' ');
  if (l.includes('uruguay') || l === 'vicsa uy' || l === 'vicsauy') return 'Vicsa Uruguay';
  if (l.startsWith('b2b')) return 'B2B';
  if (l.includes('bunzl')) return 'Bunzl';
  if (l.includes('vicsa')) return 'Vicsa';
  if (l.includes('tecnoboga') || l === 'tb') return 'Tecnoboga';
  if (l.includes('hospitalia')) return 'Hospitalia';
  if (l === 'dps' || l.startsWith('dps ')) return 'DPS';
  return texto;
}
